export default __webpack_public_path__ + "static/media/저축은행.8db43976.svg";